import { render, staticRenderFns } from "./DatabaseTable.vue?vue&type=template&id=aceb7dda&scoped=true&"
import script from "./DatabaseTable.vue?vue&type=script&lang=js&"
export * from "./DatabaseTable.vue?vue&type=script&lang=js&"
import style0 from "./DatabaseTable.vue?vue&type=style&index=0&id=aceb7dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb7dda",
  null
  
)

export default component.exports